/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowCapTableEntryDtoSchema = z.object({
  holderName: z.optional(z.string()),
  equityPercent: z.number().nullish(),
});
